/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './websites.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../app/admin/websites/websites.component';
import * as i4 from '../../../../app/admin/admin.service';
const styles_WebsitesComponent:any[] = [i0.styles];
export const RenderType_WebsitesComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_WebsitesComponent,data:{}});
export function View_WebsitesComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_WebsitesComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-websites',
      ([] as any[]),(null as any),(null as any),(null as any),View_WebsitesComponent_0,
      RenderType_WebsitesComponent)),i1.ɵdid(1,114688,(null as any),0,i3.WebsitesComponent,
      [i4.AdminService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WebsitesComponentNgFactory:i1.ComponentFactory<i3.WebsitesComponent> = i1.ɵccf('app-websites',
    i3.WebsitesComponent,View_WebsitesComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi93ZWJzaXRlcy93ZWJzaXRlcy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2FkbWluL3dlYnNpdGVzL3dlYnNpdGVzLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi93ZWJzaXRlcy93ZWJzaXRlcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi93ZWJzaXRlcy93ZWJzaXRlcy5jb21wb25lbnQudHMuV2Vic2l0ZXNDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC13ZWJzaXRlcz48L2FwcC13ZWJzaXRlcz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO2FBQUE7MERBQUE7VUFBQTtJQUFBOzs7O29CQ0FBO01BQUE7a0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/websites/websites.component.ngfactory.ts